import React from 'react'
import '../App.css'

export default function Header() {
  return (
    <div className='header'>
      Manage Contacts
    </div>
  )
}
